module.exports = __webpack_public_path__ + "media/images/porque/art-frete-1635988353cd683f065477278e89b0a7.svg";